module.exports = __webpack_public_path__ + "0303ee84de527c822e6cfce161ead183.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/TechSkills/icons/Sass.png
// module id = 45
// module chunks = 0